import React from 'react';
import { View, TouchableOpacity, Text, StyleSheet, Platform } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useCart } from '../../context/CartContext';

const MarketplaceFooter = ({ activeTab, navigation }) => {
    const insets = useSafeAreaInsets();
    const { getCartCount } = useCart();

    const tabs = [
        { id: 'Home', icon: 'home', label: 'Home', route: 'Marketplace' },
        { id: 'Categories', icon: 'grid', label: 'Categories', route: 'Marketplace' },
        { id: 'Cart', icon: 'cart', label: 'Cart', route: 'Cart' },
        { id: 'Wishlist', icon: 'heart', label: 'Wishlist', route: 'Marketplace' },
        { id: 'Profile', icon: 'person', label: 'Profile', route: 'Profile' }
    ];

    const handlePress = (tab) => {
        if (tab.id === 'Profile') {
            navigation.navigate('Profile');
        } else {
            navigation.navigate(tab.route);
        }
    };

    return (
        <View style={[styles.container, { paddingBottom: Math.max(insets.bottom, 12) }]}>
            {tabs.map(tab => {
                const isActive = activeTab === tab.id;
                const isCart = tab.id === 'Cart';
                const cartCount = getCartCount();

                return (
                    <TouchableOpacity
                        key={tab.id}
                        style={styles.tab}
                        onPress={() => handlePress(tab)}
                        activeOpacity={0.7}
                    >
                        <View>
                            <Ionicons
                                name={isActive ? tab.icon : `${tab.icon}-outline`}
                                size={22}
                                color={isActive ? '#6366F1' : '#64748B'}
                            />
                            {isCart && cartCount > 0 && (
                                <View style={styles.cartBadge}>
                                    <Text style={styles.cartBadgeText}>{cartCount}</Text>
                                </View>
                            )}
                        </View>
                        <Text style={[
                            styles.label,
                            { color: isActive ? '#6366F1' : '#64748B' }
                        ]}>
                            {tab.label}
                        </Text>
                    </TouchableOpacity>
                );
            })}
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        backgroundColor: '#FFFFFF',
        borderTopWidth: 1,
        borderTopColor: '#F1F5F9',
        paddingTop: 10,
        ...Platform.select({
            ios: {
                shadowColor: '#000',
                shadowOffset: { width: 0, height: -3 },
                shadowOpacity: 0.05,
                shadowRadius: 5,
            },
            android: {
                elevation: 10,
            }
        }),
    },
    tab: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
    },
    label: {
        fontSize: 10,
        fontWeight: '700',
        marginTop: 4,
    },
    cartBadge: {
        position: 'absolute',
        top: -6,
        right: -8,
        backgroundColor: '#EF4444',
        minWidth: 16,
        height: 16,
        borderRadius: 8,
        alignItems: 'center',
        justifyContent: 'center',
        borderWidth: 1.5,
        borderColor: '#FFFFFF',
        paddingHorizontal: 2,
    },
    cartBadgeText: {
        color: '#FFFFFF',
        fontSize: 8,
        fontWeight: '900',
    }
});

export default MarketplaceFooter;
